export const mapResearchCenterNames = (city: string) => {
  if (city.toLowerCase() === 'watertown') {
    return {
      researchCenterName: 'Hercules Research Center',
      researchCenterAdjective: 'Hercules',
      locationCity: 'Boston',
    };
  }
  return {
    researchCenterName: city,
    researchCenterAdjective: city,
    locationCity: city,
  };
};
